import classNames from "classnames";
import styles from "./ColorBadge.module.scss";

type Props = {
    color?: string;
    empty?: boolean;
    bordered?: boolean;
};

export const ColorBadge = (
    {
        color,
        empty,
        bordered,
    }: Props
) => {
    const containerClassNames = classNames(
        styles.badge,
        {
            [styles.empty]: empty,
            [styles.bordered]: bordered,
        }
    );

    return (
        <span className={containerClassNames} style={color ? {backgroundColor: color} : undefined} />
    );
};
